import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'
import type { ConnectionStatusKind } from './types'

type PillProps = {
  kind: ConnectionStatusKind
}

const backgroundByKind: Record<ConnectionStatusKind, string> = {
  offline: tokens.colors.dark5,
  slow: tokens.colors.warning,
  reconnected: tokens.colors.success
}

const colorByKind: Record<ConnectionStatusKind, string> = {
  offline: tokens.colors.white,
  slow: tokens.colors.dark6,
  reconnected: tokens.colors.white
}

export const Region = styled.div`
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  justify-content: center;
  width: max-content;
  max-width: 92vw;
  pointer-events: none;
`

export const Pill = styled.div<PillProps>`
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.horizontalXxsmall};
  padding: ${tokens.spacing.verticalXxsmall} ${tokens.spacing.horizontalMedium};
  border-radius: ${tokens.radius.pill};
  background-color: ${({ kind }) => backgroundByKind[kind]};
  color: ${({ kind }) => colorByKind[kind]};
  box-shadow: ${tokens.shadows.centerMedium};
  font-size: ${tokens.fontSize.xsmall};
  font-weight: ${tokens.fontWeights.semiBold};
  line-height: ${tokens.lineHeight.medium}%;
  text-align: center;
`
